module.exports = __webpack_public_path__ + "img/RO.a9e8cdfe.svg";